export default function Terms() {
    return (
        <div>
            This is terms
        </div>
    );
}